import { render, staticRenderFns } from "./InputLinkAttrWidget.vue?vue&type=template&id=61a44b12&scoped=true&"
import script from "./InputLinkAttrWidget.vue?vue&type=script&lang=js&"
export * from "./InputLinkAttrWidget.vue?vue&type=script&lang=js&"
import style0 from "./InputLinkAttrWidget.vue?vue&type=style&index=0&id=61a44b12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a44b12",
  null
  
)

export default component.exports